import { z } from 'zod';

export const schemaUser = z.object({
    email: z.string().email(),
    password: z.string().min(1),
});
export type SchemaUser = z.infer<typeof schemaUser>;

export const schemaCode = z.object({
    code: z.string().min(6).max(6),
});
export type SchemaCode = z.infer<typeof schemaCode>;
